import assignmentGreen from '@images/home/assignment-green.png'
import Component from '@glimmer/component'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { array } from '@ember/helper'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

export class HomeTilesManageAssignmentsMaths extends Component {
  get assignmentGreenPng() {
    return assignmentGreen
  }

  <template>
    <HomeTile @themeKey={{themeKey "maths"}} @title={{t "pages.home.panels.manageAssignments.title"}}>
      <div class="space-y-3 bg-white p-3">
        <div class="flex h-28 items-start">
          <img class="mr-6" src={{this.assignmentGreenPng}} alt={{t "pages.home.panels.manageAssignments.imageAlt"}} />
          <p class="mb-3">{{t "pages.home.panels.manageAssignments.description"}}</p>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="assignments.product.manage.current"
            @models={{array "mathseeds"}}
            @appearance={{ButtonAppearance.regular}}
          >
            {{t "pages.home.panels.manageAssignments.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
      </div>
    </HomeTile>
  </template>
}

export default HomeTilesManageAssignmentsMaths
